// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import { createVerticalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { cartLineCardExpandedStyles } from "@eisinc/Overrides/Widgets/Cart/CartLineCardExpanded";
import iconsObject from "@eisinc/XDL/Icons/eisCommonIcons";
import Measure from "@eisinc/XDL/Icons/Measure";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.certificationsStyles = {
    css: css`
        display: inline-flex;
        flex-direction: column;
        // remove padding, margin, and border from the fieldset
        padding: 0;
        margin: 0;
        border: 0;

        & > div {
            margin-bottom: 10px;
            font-size: ${fontConfig.singleLinexSmall.size}px;
            line-height: ${fontConfig.singleLinexSmall.lineHeight};

            &:last-child {
                margin-bottom: 0;
            }
        }

        @media print {
            display: none;

            > div {
                display: flex;
            }
        }
    `,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.longProductDescription = {
    ...cartLineSharedStyles.longProductDescription,
};
cartLineCardExpandedStyles.productAvailabilityWrapper = {
    ...cartLineSharedStyles.productAvailabilityWrapper,
};
cartLineCardExpandedStyles.productPartNumbersGridItem = {
    css: css`
        grid-column: 1/2;
        display: flex;
        flex-direction: column;
        row-gap: 2px;
        ${xScreen("lte", "sm")} {
            grid-column: 1/3;
        }
    `,
};

cartLineCardExpandedStyles.productPartNumbers = {
    container: {
        css: css`
            flex-grow: unset;
        `,
    },
};

cartLineCardExpandedStyles.costCodeGridItem = {
    ...cartLineSharedStyles.costCodeGridItem,
};

cartLineCardExpandedStyles.badgesWrapper = {
    ...cartLineSharedStyles.badgesWrapper,
};

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.deliveryDateStyles = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            weight: fontConfig.weight.regular,
            ...fontConfig.singleLinexSmall,
            css: css`
                display: none;
                ${xScreen("lte", "md")} {
                    display: block;
                }
            `,
        },
        text: {
            weight: fontConfig.weight.medium,
        },
        wrapper: {
            css: css`
                width: auto;
            `,
        }
    }),
};

cartLineCardExpandedStyles.productInfoGridItem = {
    ...cartLineSharedStyles.productInfoGridItem,
};
cartLineCardExpandedStyles.quantity = {
    qtyFieldStyles: {
        qtyLabel: {
            ...cartLineSharedStyles.qtyLabel,
        },
    },
};
cartLineCardExpandedStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.removeLink = {
    ...cartLineSharedStyles.removeLink,
};

cartLineCardExpandedStyles.priceHeading = {
    ...fontConfig.singleLinexSmall,
    css: css`
        display: none;
        margin-bottom: 4px;
        ${xScreen("lte", "md")} {
            display: block;
        }
        @media print {
            display: block;
        }
    `,
};

cartLineCardExpandedStyles.totalHeading = {
    ...fontConfig.singleLinexSmall,
    css: css`
        display: none;
        margin-bottom: 4px;
        ${xScreen("lte", "md")} {
            display: block;
        }
        @media print {
            display: block;
        }
    `,
};
cartLineCardExpandedStyles.totalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 4px;
    `,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};
cartLineCardExpandedStyles.errorMessage = {
    ...fontConfig.singleLinexSmall,
    css: css`
        display: flex;
        gap: 4px;
    `,
};

cartLineCardExpandedStyles.certBadgesWrapper = {
    ...cartLineSharedStyles.certBadgesWrapper,
};
cartLineCardExpandedStyles.mfrBadge = {
    ...cartLineSharedStyles.mfrBadge,
};
cartLineCardExpandedStyles.eisBadge = {
    ...cartLineSharedStyles.eisBadge,
};

// Old Style
cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            margin-top: 10px;
        }
    `,
};

cartLineCardExpandedStyles.certificationLabels = {
    typographyProps: {
        ...fontConfig.singleLineSmall,
        css: css`
            margin-left: 5px !important;
        `,
    },
    css: css`
        @media print {
            display: none;
        }
    `,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-top: 12px;
    `,
};
cartLineCardExpandedStyles.cutWireLink = {
    ...createLinkIconStyles({
        icon: Measure,
        linkStyles: {
            css: css`
                margin-bottom: 10px;
            `,
        },
    }),
};

cartLineCardExpandedStyles.binInformationsGridItem = {
    width: 12,
};
cartLineCardExpandedStyles.lineNumberGridItem = {
    css: css`
        line-height: 20px;
    `,
};

cartLineCardExpandedStyles.addToCartButtonWrapper = {
    css: css`
        margin-bottom: 10px;
    `,
};
cartLineCardExpandedStyles.addToCartButtonStyles = {
    linkText: {
        transform: "capitalize",
    },
};
cartLineCardExpandedStyles.shipmentDataWrapper = {
    css: css`
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }

        &:hover,
        &:focus {
            .shipment-data-icon {
                color: ${color("text.main")};
            }

            .shipment-data-text {
                text-decoration: underline;
            }
        }
    `,
};
cartLineCardExpandedStyles.shipmentDataIcon = {
    src: iconsObject["Info"],
    size: 12,
    color: "primary.main",
    css: css`
        transition: all 200ms ease-in-out;
    `,
};
cartLineCardExpandedStyles.shipmentDataText = {
    size: "14px",
    lineHeight: "10px",
    color: "text.main",
    css: css`
        margin-left: 6.5px;
        transition: all 200ms ease-in-out;
    `,
};
cartLineCardExpandedStyles.ctaButtons = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
    `,
};
cartLineCardExpandedStyles.datePicker = {
    cssOverrides: {
        formInputWrapper: css`
            padding-bottom: 190px;
        `,
    },
};
cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.toggleLink = {
    typographyProps: {
        ...fontConfig.singleLinexSmall,
        weight: fontConfig.weight.medium,
    },
    css: css`
        align-self: baseline;
    `,
};
cartLineCardExpandedStyles.poLineWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};
cartLineCardExpandedStyles.POLabel = {
    ...fontConfig.singleLinexSmall,
    css: css`
        &:empty {
            display: none;
        }
    `,
};
cartLineCardExpandedStyles.readOnlyPOLineText = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            ...fontConfig.singleLinexSmall,
        },
        text: {
            ...fontConfig.singleLinexSmall,
        },
    }),
};
cartLineCardExpandedStyles.wishListAndCheckboxes = {
    ...cartLineSharedStyles.wishListAndCheckboxes,
};
cartLineCardExpandedStyles.qtyOrderedAndQtyShippedWrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 108px) minmax(92px, 98px);
        gap: 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
        }
    `,
};
cartLineCardExpandedStyles.dateTooltipWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
    `,
};
